<template>
  <section class="depoimentos-google">
    <h2>O que nossos clientes dizem</h2>

    <div v-if="loading" class="status">
      Carregando depoimentos...
    </div>

    <div v-else-if="erro" class="status erro">
      {{ erro }}
    </div>

    <swiper
      v-else-if="reviews.length > 0"
      :slides-per-view="1"
      :space-between="20"
      :loop="reviews.length > 3"
      :autoplay="{ delay: 5000, disableOnInteraction: false }"
      :pagination="{ clickable: true }"
      :navigation="true"
      :breakpoints="{
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }"
    >
      <swiper-slide
        v-for="item in reviews"
        :key="item.reviewId"
      >
        <div class="card-depoimento">
          <div class="estrelas">
            {{ getStars(item.nota) }}
          </div>

          <div class="conteudo-comentario">
            <p
              class="comentario"
              :class="{ expandido: comentarioExpandido(item.reviewId) }"
            >
              {{ textoComentario(item.comentario) }}
            </p>

            <span
              v-if="comentarioTraduzido(item.comentario)"
              class="traducao-google"
            >
              Traduzido pelo Google
            </span>

            <button
              v-if="comentarioLongo(item.comentario)"
              type="button"
              class="botao-comentario"
              @click="alternarComentario(item.reviewId)"
            >
              {{ comentarioExpandido(item.reviewId) ? 'Mostrar menos' : 'Ler mais' }}
            </button>
          </div>

          <div class="cliente">
            <img
              v-if="item.foto"
              :src="item.foto"
              :alt="item.nome"
            />

            <div>
              <strong>{{ item.nome || 'Cliente Google' }}</strong>
              <small>{{ formatarData(item.data) }}</small>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <div v-else class="status">
      Nenhum depoimento encontrado.
    </div>
  </section>
</template>

<script>
import axios from 'axios'

import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper'

import 'swiper/swiper-bundle.css'

SwiperCore.use([Navigation, Pagination, Autoplay])

export default {
  name: 'PageDepoimentosApiGoogle',

  components: {
    Swiper,
    SwiperSlide,
  },

  data: () => ({
    reviews: [],
    loading: false,
    erro: null,
    comentariosExpandidos: {},
  }),

  methods: {
    carregarDepoimentos() {
      this.loading = true
      this.erro = null

      axios.get('/Process/GoogleReviews')
        .then(response => {
          this.reviews = Array.isArray(response.data) ? response.data : []
        })
        .catch(error => {
          console.error(error)

          if (error.response && error.response.status === 400) {
            this.erro = 'Depoimentos do Google ainda não foram conectados.'
            return
          }

          this.erro = 'Não foi possível carregar os depoimentos.'
        })
        .finally(() => {
          this.loading = false
        })
    },

    getStars(nota) {
      const map = {
        FIVE: '★★★★★',
        FOUR: '★★★★☆',
        THREE: '★★★☆☆',
        TWO: '★★☆☆☆',
        ONE: '★☆☆☆☆',
      }

      return map[nota] || '★★★★★'
    },

    formatarData(data) {
      if (!data) return ''

      return new Date(data).toLocaleDateString('pt-BR')
    },

    partesComentario(comentario) {
      const texto = (comentario || '').trim()

      if (!texto) {
        return {
          texto: 'Cliente avaliou sem comentário.',
          traduzido: false,
        }
      }

      const marcadorTraducao = /\s*\(Translated by Google\)\s*/i

      if (!marcadorTraducao.test(texto)) {
        return { texto, traduzido: false }
      }

      const [traducao] = texto.split(marcadorTraducao)

      return {
        texto: traducao.trim() || texto.replace(marcadorTraducao, ' ').trim(),
        traduzido: true,
      }
    },

    textoComentario(comentario) {
      return this.partesComentario(comentario).texto
    },

    comentarioTraduzido(comentario) {
      return this.partesComentario(comentario).traduzido
    },

    comentarioLongo(comentario) {
      return this.textoComentario(comentario).length > 240
    },

    comentarioExpandido(reviewId) {
      return Boolean(this.comentariosExpandidos[reviewId])
    },

    alternarComentario(reviewId) {
      this.comentariosExpandidos = {
        ...this.comentariosExpandidos,
        [reviewId]: !this.comentariosExpandidos[reviewId],
      }
    },
  },

  created() {
    this.carregarDepoimentos()
  },
}
</script>

<style scoped>
.depoimentos-google {
  padding: 60px 20px;
  background: #f8f8f8;
}

.depoimentos-google h2 {
  text-align: center;
  margin-bottom: 32px;
  font-size: 32px;
}

.status {
  text-align: center;
  padding: 30px;
}

.erro {
  color: #b00020;
}

.card-depoimento {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  min-height: 320px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.depoimentos-google :deep(.swiper-wrapper) {
  align-items: stretch;
}

.depoimentos-google :deep(.swiper-slide) {
  height: auto;
}

.estrelas {
  color: #f5a623;
  font-size: 22px;
  margin-bottom: 14px;
}

.conteudo-comentario {
  flex: 1;
  margin-bottom: 24px;
}

.comentario {
  font-size: 15px;
  line-height: 1.6;
  color: #333;
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  overflow: hidden;
}

.comentario.expandido {
  display: block;
  overflow: visible;
}

.traducao-google {
  display: block;
  margin-top: 8px;
  color: #777;
  font-size: 12px;
  font-style: italic;
}

.botao-comentario {
  margin-top: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0b6bcb;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.botao-comentario:hover,
.botao-comentario:focus-visible {
  text-decoration: underline;
}

.cliente {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cliente img {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  object-fit: cover;
}

.cliente strong {
  display: block;
  color: #222;
}

.cliente small {
  color: #777;
  font-size: 13px;
}
</style>
